// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ============================================
   GOLDEN EFFECT BANNER — shared component
   Used across Shop, Equipment, AdminReservoir
   ============================================ */

/* ── Banner container ── */
.geb-banner {
  background: rgba(251, 191, 36, 0.06);
  border: 1px solid rgba(251, 191, 36, 0.12);
  border-radius: 8px;
  padding: 0.5rem 0.75rem;
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
}

/* ── Consumable variant — purple tint ── */
.geb-banner--consumable {
  background: rgba(168, 85, 247, 0.06);
  border-color: rgba(168, 85, 247, 0.15);
}

.geb-banner--consumable .geb-icon {
  color: #a855f7;
}

.geb-banner--consumable .geb-name {
  color: #a855f7;
}

/* ── Header row: icon + name ── */
.geb-header {
  display: flex;
  align-items: center;
  gap: 0.375rem;
}

.geb-icon {
  flex-shrink: 0;
  color: #fbbf24;
}

.geb-name {
  font-size: 0.75rem;
  font-weight: 600;
  color: #fbbf24;
  letter-spacing: 0.02em;
}

.geb-consumable-badge {
  font-size: 0.6rem;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  color: #a855f7;
  background: rgba(168, 85, 247, 0.12);
  border: 1px solid rgba(168, 85, 247, 0.2);
  border-radius: var(--radius-full, 9999px);
  padding: 1px 6px;
  margin-left: auto;
}

/* ── Description ── */
.geb-desc {
  font-size: 0.75rem;
  color: #d1d5db;
  line-height: 1.35;
  margin: 0;
}

/* ── Pros/Cons tags row ── */
.geb-tags {
  display: flex;
  flex-wrap: wrap;
  gap: 0.3rem;
  margin-top: 0.2rem;
}

.geb-tag {
  display: inline-block;
  font-size: 0.65rem;
  font-weight: 500;
  padding: 2px 8px;
  border-radius: 6px;
  letter-spacing: 0.01em;
  backdrop-filter: blur(8px);
  -webkit-backdrop-filter: blur(8px);
}

/* Pro tag — green glassmorphism */
.geb-tag--pro {
  background: rgba(34, 197, 94, 0.15);
  border: 1px solid rgba(34, 197, 94, 0.3);
  color: #4ade80;
}

/* Con tag — red glassmorphism */
.geb-tag--con {
  background: rgba(239, 68, 68, 0.15);
  border: 1px solid rgba(239, 68, 68, 0.3);
  color: #f87171;
}

/* Neutral tag — purple glassmorphism */
.geb-tag--neutral {
  background: rgba(168, 85, 247, 0.15);
  border: 1px solid rgba(168, 85, 247, 0.3);
  color: #c084fc;
}

/* ── Mechanic tags row ── */
.geb-mechanics {
  display: flex;
  flex-wrap: wrap;
  gap: 0.3rem;
  margin-top: 0.15rem;
}

.geb-mechanic-tag {
  position: relative;
  display: inline-block;
  font-size: 0.6rem;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  padding: 2px 7px;
  border-radius: 4px;
  background: rgba(255, 255, 255, 0.06);
  border: 1px solid rgba(255, 255, 255, 0.1);
  color: #9ca3af;
  cursor: help;
}

/* The geb hosts are uppercase micro-type; the GameTip panel body must not
   inherit that (prose .combat-tt__desc lines set no transform of their own).
   The panel's name/section-label/stat rules re-apply their own casing on top.
   (Reveal + panel chrome live in the canonical GameTip shell, .combat-tt__*
   in CombatStatusRails.css.) */
.geb-mechanic-tag .combat-tt__panel,
.geb-mpill .combat-tt__panel,
.geb-pill .combat-tt__panel {
  text-transform: none;
  letter-spacing: normal;
}

/* GameTip node-circle icon takes the host accent (the standalone .geb-icon
   rule pins gold, which would fight the consumable purple). */
.combat-tt__node > .geb-icon {
  color: inherit;
}

/* ============================================
   PILL VARIANT — compact inline pill, GameTip decode panel
   ============================================ */

.geb-pill {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  padding: 3px 10px;
  border-radius: var(--radius-full, 9999px);
  background: rgba(251, 191, 36, 0.08);
  border: 1px solid rgba(251, 191, 36, 0.2);
  color: #fbbf24;
  font-family: inherit;
  font-size: 0.7rem;
  font-weight: 600;
  letter-spacing: 0.02em;
  cursor: pointer;
  transition: background 0.15s, border-color 0.15s;
  white-space: nowrap;
}

.geb-pill:hover {
  background: rgba(251, 191, 36, 0.14);
  border-color: rgba(251, 191, 36, 0.35);
}

.geb-pill--consumable {
  background: rgba(168, 85, 247, 0.08);
  border-color: rgba(168, 85, 247, 0.2);
  color: #a855f7;
}

.geb-pill--consumable:hover {
  background: rgba(168, 85, 247, 0.14);
  border-color: rgba(168, 85, 247, 0.35);
}

.geb-pill--consumable .geb-icon {
  color: #a855f7;
}

.geb-pill-name {
  line-height: 1;
}

.geb-pill-chevron {
  flex-shrink: 0;
  transition: transform 0.15s ease;
}

/* Chevron flips while the decode panel is held open by focus (tap/click);
   the toggle host's mute (second tap) drops the rotation with the panel. */
.geb-pill.combat-tt-host:focus-within:not(.combat-tt-host--muted) .geb-pill-chevron {
  transform: rotate(180deg);
}

/* ============================================
   MECHANIC PILLS — separate hoverable row
   Shows Tolerance / Comedown / Tachyphylaxis
   ============================================ */

.geb-mechanic-pills {
  display: contents;
}

.geb-mpill {
  position: relative;
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 2px 8px;
  border-radius: var(--radius-full, 9999px);
  font-size: 0.6rem;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  cursor: help;
  white-space: nowrap;
  transition: background 0.15s, border-color 0.15s;
  /* Keep the host's GameTip panel stacked above later grid siblings */
  z-index: 1;
}

.geb-mpill--tolerance {
  background: rgba(234, 179, 8, 0.08);
  border: 1px solid rgba(234, 179, 8, 0.2);
  color: #eab308;
}

.geb-mpill--tolerance:hover {
  background: rgba(234, 179, 8, 0.16);
  border-color: rgba(234, 179, 8, 0.35);
}

.geb-mpill--comedown {
  background: rgba(239, 68, 68, 0.08);
  border: 1px solid rgba(239, 68, 68, 0.2);
  color: #f87171;
}

.geb-mpill--comedown:hover {
  background: rgba(239, 68, 68, 0.16);
  border-color: rgba(239, 68, 68, 0.35);
}

.geb-mpill--tachyphylaxis {
  background: rgba(249, 115, 22, 0.08);
  border: 1px solid rgba(249, 115, 22, 0.2);
  color: #fb923c;
}

.geb-mpill--tachyphylaxis:hover {
  background: rgba(249, 115, 22, 0.16);
  border-color: rgba(249, 115, 22, 0.35);
}

.geb-mpill-label {
  line-height: 1;
}
`, "",{"version":3,"sources":["webpack://./src/components/GoldenEffectBanner.css"],"names":[],"mappings":"AAAA;;;iDAGiD;;AAEjD,2BAA2B;AAC3B;EACE,oCAAoC;EACpC,0CAA0C;EAC1C,kBAAkB;EAClB,uBAAuB;EACvB,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA,2CAA2C;AAC3C;EACE,oCAAoC;EACpC,sCAAsC;AACxC;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA,kCAAkC;AAClC;EACE,aAAa;EACb,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,sBAAsB;AACxB;;AAEA;EACE,iBAAiB;EACjB,yBAAyB;EACzB,sBAAsB;EACtB,cAAc;EACd,oCAAoC;EACpC,yCAAyC;EACzC,yCAAyC;EACzC,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA,sBAAsB;AACtB;EACE,kBAAkB;EAClB,cAAc;EACd,iBAAiB;EACjB,SAAS;AACX;;AAEA,6BAA6B;AAC7B;EACE,aAAa;EACb,eAAe;EACf,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;EACrB,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;EAClB,sBAAsB;EACtB,0BAA0B;EAC1B,kCAAkC;AACpC;;AAEA,kCAAkC;AAClC;EACE,mCAAmC;EACnC,wCAAwC;EACxC,cAAc;AAChB;;AAEA,gCAAgC;AAChC;EACE,mCAAmC;EACnC,wCAAwC;EACxC,cAAc;AAChB;;AAEA,uCAAuC;AACvC;EACE,oCAAoC;EACpC,yCAAyC;EACzC,cAAc;AAChB;;AAEA,4BAA4B;AAC5B;EACE,aAAa;EACb,eAAe;EACf,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,iBAAiB;EACjB,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EACtB,gBAAgB;EAChB,kBAAkB;EAClB,qCAAqC;EACrC,0CAA0C;EAC1C,cAAc;EACd,YAAY;AACd;;AAEA;;;;+BAI+B;AAC/B;;;EAGE,oBAAoB;EACpB,sBAAsB;AACxB;;AAEA;8DAC8D;AAC9D;EACE,cAAc;AAChB;;AAEA;;iDAEiD;;AAEjD;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,yCAAyC;EACzC,oCAAoC;EACpC,yCAAyC;EACzC,cAAc;EACd,oBAAoB;EACpB,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;EACtB,eAAe;EACf,gDAAgD;EAChD,mBAAmB;AACrB;;AAEA;EACE,oCAAoC;EACpC,sCAAsC;AACxC;;AAEA;EACE,oCAAoC;EACpC,qCAAqC;EACrC,cAAc;AAChB;;AAEA;EACE,oCAAoC;EACpC,sCAAsC;AACxC;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,gCAAgC;AAClC;;AAEA;2EAC2E;AAC3E;EACE,yBAAyB;AAC3B;;AAEA;;;iDAGiD;;AAEjD;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,yCAAyC;EACzC,iBAAiB;EACjB,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EACtB,YAAY;EACZ,mBAAmB;EACnB,gDAAgD;EAChD,oEAAoE;EACpE,UAAU;AACZ;;AAEA;EACE,mCAAmC;EACnC,wCAAwC;EACxC,cAAc;AAChB;;AAEA;EACE,mCAAmC;EACnC,qCAAqC;AACvC;;AAEA;EACE,mCAAmC;EACnC,wCAAwC;EACxC,cAAc;AAChB;;AAEA;EACE,mCAAmC;EACnC,qCAAqC;AACvC;;AAEA;EACE,oCAAoC;EACpC,yCAAyC;EACzC,cAAc;AAChB;;AAEA;EACE,oCAAoC;EACpC,sCAAsC;AACxC;;AAEA;EACE,cAAc;AAChB","sourcesContent":["/* ============================================\n   GOLDEN EFFECT BANNER — shared component\n   Used across Shop, Equipment, AdminReservoir\n   ============================================ */\n\n/* ── Banner container ── */\n.geb-banner {\n  background: rgba(251, 191, 36, 0.06);\n  border: 1px solid rgba(251, 191, 36, 0.12);\n  border-radius: 8px;\n  padding: 0.5rem 0.75rem;\n  display: flex;\n  flex-direction: column;\n  gap: 0.25rem;\n}\n\n/* ── Consumable variant — purple tint ── */\n.geb-banner--consumable {\n  background: rgba(168, 85, 247, 0.06);\n  border-color: rgba(168, 85, 247, 0.15);\n}\n\n.geb-banner--consumable .geb-icon {\n  color: #a855f7;\n}\n\n.geb-banner--consumable .geb-name {\n  color: #a855f7;\n}\n\n/* ── Header row: icon + name ── */\n.geb-header {\n  display: flex;\n  align-items: center;\n  gap: 0.375rem;\n}\n\n.geb-icon {\n  flex-shrink: 0;\n  color: #fbbf24;\n}\n\n.geb-name {\n  font-size: 0.75rem;\n  font-weight: 600;\n  color: #fbbf24;\n  letter-spacing: 0.02em;\n}\n\n.geb-consumable-badge {\n  font-size: 0.6rem;\n  text-transform: uppercase;\n  letter-spacing: 0.05em;\n  color: #a855f7;\n  background: rgba(168, 85, 247, 0.12);\n  border: 1px solid rgba(168, 85, 247, 0.2);\n  border-radius: var(--radius-full, 9999px);\n  padding: 1px 6px;\n  margin-left: auto;\n}\n\n/* ── Description ── */\n.geb-desc {\n  font-size: 0.75rem;\n  color: #d1d5db;\n  line-height: 1.35;\n  margin: 0;\n}\n\n/* ── Pros/Cons tags row ── */\n.geb-tags {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 0.3rem;\n  margin-top: 0.2rem;\n}\n\n.geb-tag {\n  display: inline-block;\n  font-size: 0.65rem;\n  font-weight: 500;\n  padding: 2px 8px;\n  border-radius: 6px;\n  letter-spacing: 0.01em;\n  backdrop-filter: blur(8px);\n  -webkit-backdrop-filter: blur(8px);\n}\n\n/* Pro tag — green glassmorphism */\n.geb-tag--pro {\n  background: rgba(34, 197, 94, 0.15);\n  border: 1px solid rgba(34, 197, 94, 0.3);\n  color: #4ade80;\n}\n\n/* Con tag — red glassmorphism */\n.geb-tag--con {\n  background: rgba(239, 68, 68, 0.15);\n  border: 1px solid rgba(239, 68, 68, 0.3);\n  color: #f87171;\n}\n\n/* Neutral tag — purple glassmorphism */\n.geb-tag--neutral {\n  background: rgba(168, 85, 247, 0.15);\n  border: 1px solid rgba(168, 85, 247, 0.3);\n  color: #c084fc;\n}\n\n/* ── Mechanic tags row ── */\n.geb-mechanics {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 0.3rem;\n  margin-top: 0.15rem;\n}\n\n.geb-mechanic-tag {\n  position: relative;\n  display: inline-block;\n  font-size: 0.6rem;\n  font-weight: 600;\n  text-transform: uppercase;\n  letter-spacing: 0.04em;\n  padding: 2px 7px;\n  border-radius: 4px;\n  background: rgba(255, 255, 255, 0.06);\n  border: 1px solid rgba(255, 255, 255, 0.1);\n  color: #9ca3af;\n  cursor: help;\n}\n\n/* The geb hosts are uppercase micro-type; the GameTip panel body must not\n   inherit that (prose .combat-tt__desc lines set no transform of their own).\n   The panel's name/section-label/stat rules re-apply their own casing on top.\n   (Reveal + panel chrome live in the canonical GameTip shell, .combat-tt__*\n   in CombatStatusRails.css.) */\n.geb-mechanic-tag .combat-tt__panel,\n.geb-mpill .combat-tt__panel,\n.geb-pill .combat-tt__panel {\n  text-transform: none;\n  letter-spacing: normal;\n}\n\n/* GameTip node-circle icon takes the host accent (the standalone .geb-icon\n   rule pins gold, which would fight the consumable purple). */\n.combat-tt__node > .geb-icon {\n  color: inherit;\n}\n\n/* ============================================\n   PILL VARIANT — compact inline pill, GameTip decode panel\n   ============================================ */\n\n.geb-pill {\n  display: inline-flex;\n  align-items: center;\n  gap: 5px;\n  padding: 3px 10px;\n  border-radius: var(--radius-full, 9999px);\n  background: rgba(251, 191, 36, 0.08);\n  border: 1px solid rgba(251, 191, 36, 0.2);\n  color: #fbbf24;\n  font-family: inherit;\n  font-size: 0.7rem;\n  font-weight: 600;\n  letter-spacing: 0.02em;\n  cursor: pointer;\n  transition: background 0.15s, border-color 0.15s;\n  white-space: nowrap;\n}\n\n.geb-pill:hover {\n  background: rgba(251, 191, 36, 0.14);\n  border-color: rgba(251, 191, 36, 0.35);\n}\n\n.geb-pill--consumable {\n  background: rgba(168, 85, 247, 0.08);\n  border-color: rgba(168, 85, 247, 0.2);\n  color: #a855f7;\n}\n\n.geb-pill--consumable:hover {\n  background: rgba(168, 85, 247, 0.14);\n  border-color: rgba(168, 85, 247, 0.35);\n}\n\n.geb-pill--consumable .geb-icon {\n  color: #a855f7;\n}\n\n.geb-pill-name {\n  line-height: 1;\n}\n\n.geb-pill-chevron {\n  flex-shrink: 0;\n  transition: transform 0.15s ease;\n}\n\n/* Chevron flips while the decode panel is held open by focus (tap/click);\n   the toggle host's mute (second tap) drops the rotation with the panel. */\n.geb-pill.combat-tt-host:focus-within:not(.combat-tt-host--muted) .geb-pill-chevron {\n  transform: rotate(180deg);\n}\n\n/* ============================================\n   MECHANIC PILLS — separate hoverable row\n   Shows Tolerance / Comedown / Tachyphylaxis\n   ============================================ */\n\n.geb-mechanic-pills {\n  display: contents;\n}\n\n.geb-mpill {\n  position: relative;\n  display: inline-flex;\n  align-items: center;\n  gap: 4px;\n  padding: 2px 8px;\n  border-radius: var(--radius-full, 9999px);\n  font-size: 0.6rem;\n  font-weight: 600;\n  text-transform: uppercase;\n  letter-spacing: 0.04em;\n  cursor: help;\n  white-space: nowrap;\n  transition: background 0.15s, border-color 0.15s;\n  /* Keep the host's GameTip panel stacked above later grid siblings */\n  z-index: 1;\n}\n\n.geb-mpill--tolerance {\n  background: rgba(234, 179, 8, 0.08);\n  border: 1px solid rgba(234, 179, 8, 0.2);\n  color: #eab308;\n}\n\n.geb-mpill--tolerance:hover {\n  background: rgba(234, 179, 8, 0.16);\n  border-color: rgba(234, 179, 8, 0.35);\n}\n\n.geb-mpill--comedown {\n  background: rgba(239, 68, 68, 0.08);\n  border: 1px solid rgba(239, 68, 68, 0.2);\n  color: #f87171;\n}\n\n.geb-mpill--comedown:hover {\n  background: rgba(239, 68, 68, 0.16);\n  border-color: rgba(239, 68, 68, 0.35);\n}\n\n.geb-mpill--tachyphylaxis {\n  background: rgba(249, 115, 22, 0.08);\n  border: 1px solid rgba(249, 115, 22, 0.2);\n  color: #fb923c;\n}\n\n.geb-mpill--tachyphylaxis:hover {\n  background: rgba(249, 115, 22, 0.16);\n  border-color: rgba(249, 115, 22, 0.35);\n}\n\n.geb-mpill-label {\n  line-height: 1;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
